// Core deps
import { createApp, configureCompat } from 'vue';
import store from './store';
import router from '@/router/router';
import { BASE_URL, ENV, isProduction } from './environment';
import { logError } from '@/utils/error';
import App from '@/App.vue';
import { createPinia } from 'pinia';
import { initDirectives } from '@/V2/directives/directives';

// Third Party Libraries
import * as Sentry from '@sentry/vue';
import mitt from 'mitt';

// services
import ApiService from '@/shared/services/api.service';
import { OnboardingService } from '@/shared/services/onboarding/onboarding.service';

// Stylesheets
import '../styles/custom.scss';

// App Init
ApiService.init(BASE_URL);

const app = createApp(App);
const pinia = createPinia();
const emitter = mitt();
app.config.globalProperties.emitter = emitter;
app.use(router);
app.use(store);
app.use(pinia);
app.mount('#app');

// config
app.config.debug = import.meta.env.MODE === 'development';

// catch uncaught errors in the app and log them to Sentry
app.config.errorHandler = function (err) {
  // eslint-disable-next-line no-console
  console.error(err);
  logError(err);
};

// Compat config
configureCompat({
  ATTR_FALSE_VALUE: false, //  Attribute "checked" with v-bind value `false` will render checked="false" instead of removing it in Vue 3. This was fired by iRadio
  WATCH_ARRAY: false, // in i-filter check that changes on Array fire watch
  COMPILER_V_BIND_OBJECT_ORDER: true, // opt in to Vue 3 behavior and suppress console warning about v-bind object order
});

// actually mount to DOM
initDirectives(app);

OnboardingService.init();

if (isProduction) {
  Sentry.init({
    app,
    dsn: 'https://232fc7155ea34f31b7a781b2d2d62aa7@sentry.io/1384448',
    environment: ENV,
    integrations: [Sentry.browserTracingIntegration({ router })],
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (error && error.name === 'NavigationDuplicated') {
        event.fingerprint = ['NavigationDuplicated'];
      }
      return event;
    },
  });
}
